import { AlertCircle } from "lucide-react";
import type { GeneratedContent } from "../types";

interface InstructionsSectionProps {
  content: GeneratedContent;
}

export const InstructionsSection: React.FC<InstructionsSectionProps> = ({
  content,
}) => {
  if (
    !content.orientacoes_professor ||
    content.orientacoes_professor.length === 0
  ) {
    return null;
  }

  return (
    <div className="bg-blue-50 border-l-4 border-blue-600 p-4 mb-8 rounded">
      <h3 className="font-bold text-blue-900 mb-2 flex items-center gap-2">
        <AlertCircle className="w-5 h-5" />
        Instruções para o Aluno
      </h3>
      <ul className="text-sm text-gray-800 space-y-1">
        {content.orientacoes_professor
          .slice(0, 3)
          .map((inst: string, idx: number) => (
            <li key={idx}>• {inst}</li>
          ))}
      </ul>
    </div>
  );
};
